export function guard(F, P) {
    return (b) => (b ? P.of(undefined) : F.zero());
}
